// Lib
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';

// Constants
import { CAPACITOR_MN_KEYBOARD_PLUGIN } from '../../../capacitor_plugins/pluginConstants';
import localStorageService from '../services/localStorage/localStorage';

export const VIRTUAL_KEYBOARD_HEIGHT_STORAGE_KEY = 'milanote.virtualKeyboardHeight';

/**
 * This hook is used by the login and register pages to save the virtual keyboard height to local storage
 * for non-capacitor devices (if any).
 *
 * This enables the app to immediately correctly scroll to element on mobile devices when the virtual keyboard is open.
 */
export const useSaveVirtualKeyboardHeightToLocalStorage = (): void => {
    useEffect(() => {
        if (Capacitor.isPluginAvailable(CAPACITOR_MN_KEYBOARD_PLUGIN)) return;

        const abortController = new AbortController();

        document.addEventListener(
            'selectionchange',
            (event) => {
                if (!event.target) return;
                if ('tagName' in event.target && event.target?.tagName !== 'INPUT') return;
                if (!window.visualViewport) return;

                const keyboardHeight = window.innerHeight - window.visualViewport.height;
                if (keyboardHeight > 0) {
                    localStorageService.setItem(VIRTUAL_KEYBOARD_HEIGHT_STORAGE_KEY, keyboardHeight.toString());
                }

                abortController.abort();
            },
            { signal: abortController.signal },
        );
    }, []);
};

export default useSaveVirtualKeyboardHeightToLocalStorage;
